import React from 'react';
import { CollectiveInvoiceActions } from '../common/CollectiveInvoiceActions';

const eur = (n) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(n) || 0);
const fmt = (d) => (d ? new Date(d).toLocaleDateString('de-DE') : '');
const STATUS = { paid: ['Bezahlt', 'text-green-700 bg-green-50'], partial: ['Teilbezahlt', 'text-amber-700 bg-amber-50'], open: ['Offen', 'text-gray-600 bg-gray-100'] };

// Liste der bereits erstellten Sammelrechnungen im „In-House verwalten“-Popup.
export function InHouseInvoiceList({ invoices, onChanged }) {
    if (!invoices.length) return null;
    return (
        <div className="border rounded-lg divide-y" data-testid="ih-invoice-list">
            <div className="px-3 py-2 text-xs font-semibold text-muted-foreground bg-muted/30">Erstellte Sammelrechnungen</div>
            {invoices.map(inv => {
                const [label, cls] = STATUS[inv.status] || STATUS.open;
                return (
                    <div key={inv.id} className="px-3 py-2 space-y-1.5" data-testid={`ih-invoice-row-${inv.id}`}>
                        <div className="flex items-center justify-between gap-2 text-sm">
                            <span className="font-mono font-medium" data-testid={`ih-invoice-number-${inv.id}`}>{inv.invoice_number}</span>
                            <span className="font-semibold">{eur(inv.amount)}</span>
                        </div>
                        <div className="flex items-center justify-between gap-2">
                            <div className="text-xs text-muted-foreground">
                                {fmt(inv.issued_at)} · {inv.participant_count} TN · <span className={`px-1.5 py-0.5 rounded-full font-medium ${cls}`}>{label}</span>
                                {inv.sent_at && <div className="mt-0.5" data-testid={`ih-invoice-sent-${inv.id}`}>Gesendet {fmt(inv.sent_at)} an {inv.sent_to}</div>}
                                {inv.dropbox_path && <div className="mt-0.5 truncate max-w-[220px]" title={inv.dropbox_path} data-testid={`ih-invoice-dropbox-${inv.id}`}>Dropbox: {inv.dropbox_path}</div>}
                            </div>
                            <CollectiveInvoiceActions invoice={inv} defaultEmail={inv.default_email} onSent={onChanged} onDeleted={onChanged} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default InHouseInvoiceList;
